// Indiana University Bloomington's undergraduate majors (#2743). Read on
// 2026-10-01 from two official IU sources:
//  - IU Bloomington's Browse All Degree Programs page (the IU degree finder
//    at bloomington.iu.edu; the list was read from the finder's own public
//    API with campus Bloomington and program type "Bachelor's degrees", 397
//    entries) for every school except the Jacobs School of Music. On-campus
//    entries only: the online programs, the accelerated-program duplicates
//    and the transfer (TSAP) variants are left out. The finder lists some
//    majors once per degree plan with a plan code in parentheses ("(EGE BS)",
//    "(LLC BA)", "(IntrdscSt BA)", ...); the code is dropped and a major
//    appears once per degree. Degrees are written short: BA, BS, BFA, BSW,
//    BLS, or "BS in ..." where the degree names a field other than the major
//    (Kelley's "BS in Business", O'Neill's "BS in Public Affairs"). Names are
//    the finder's own, abbreviations included. A major shared by schools sits
//    under the specialized school the finder names (the Media School,
//    Eskenazi, Hamilton Lugar), otherwise under the first school listed.
//  - The Jacobs School of Music Bulletin 2026-2027, Undergraduate Division
//    (Bachelor of Music, Bachelor of Music Education, Bachelor of Science
//    and BFA in Dance pages), because the finder splits Jacobs degrees by
//    instrument (186 entries). The bulletin's dashes become commas.
// Quirk: "Safety Management" (School of Public Health) is IU's official
// major name. The KB's majors list was the starting point; IU's lists win.
const majors = {
    "slug": "indiana-university-bloomington",
    "read": "2026-10-01",
    "intro": "Every on-campus bachelor's degree major IU Bloomington lists, grouped by the school that offers it, with the degree it leads to. Minors, certificates, online and accelerated programs and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "IU Bloomington, Browse All Degree Programs (bachelor's degrees)",
                "url": "https://bloomington.iu.edu/academics/degrees-majors/programs.html"
            },
            "majors": [
                {
                    "name": "African American & African Diaspora St/Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "African American & African Diaspora Studies",
                    "degree": "BA"
                },
                {
                    "name": "African American & African Diaspora Studies/English",
                    "degree": "BA"
                },
                {
                    "name": "African American & African Diaspora Studies/History",
                    "degree": "BA"
                },
                {
                    "name": "African American & African Diaspora Studies/Sociology",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Animal Behavior",
                    "degree": "BS"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology/Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy/Astrophysics",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy/Astrophysics",
                    "degree": "BS in Astronomy and Astrophysics"
                },
                {
                    "name": "Atmospheric Science",
                    "degree": "BS"
                },
                {
                    "name": "Atmospheric Science",
                    "degree": "BS in Earth, Geography, and the Environment"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biotechnology",
                    "degree": "BA"
                },
                {
                    "name": "Biotechnology",
                    "degree": "BS"
                },
                {
                    "name": "Bosnian, Serbian, and Croatian",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Classical Studies",
                    "degree": "BA"
                },
                {
                    "name": "Clinical Psychological Science",
                    "degree": "BS"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BS"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BS in Psychology"
                },
                {
                    "name": "Comparative Literature",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science/Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Criminology and Criminal Justice",
                    "degree": "BA"
                },
                {
                    "name": "Czech",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Earth Science",
                    "degree": "BS"
                },
                {
                    "name": "Earth Science",
                    "degree": "BS in Earth, Geography, and the Environment"
                },
                {
                    "name": "Earth and Atmospheric Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics and Quantitative Methods",
                    "degree": "BS"
                },
                {
                    "name": "Economics/Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Economics/Political Science",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "English/African American & African Diaspora Studies",
                    "degree": "BA"
                },
                {
                    "name": "Environmental & Sustainability Studies",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Geoscience",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Geoscience",
                    "degree": "BS in Earth, Geography, and the Environment"
                },
                {
                    "name": "Folklore & Ethnomusicology",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Gender Studies",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "Geography",
                    "degree": "BS in Earth, Geography, and the Environment"
                },
                {
                    "name": "Germanic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Hispanic Literature and Culture",
                    "degree": "BS in Education"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History/African American & African Diaspora Studies",
                    "degree": "BA"
                },
                {
                    "name": "Human Biology",
                    "degree": "BA"
                },
                {
                    "name": "Human Biology",
                    "degree": "BS"
                },
                {
                    "name": "Individualized Major",
                    "degree": "BA"
                },
                {
                    "name": "Interdept Mathematics Major: Mathematics/Economics",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Liberal Studies",
                    "degree": "BLS"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics/Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Management and Human Organization",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BA"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Molecular Life Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Musical Theatre",
                    "degree": "BFA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy/Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy/Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy/Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Polish",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Relig Studies/African American &Afr Diaspora St",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies/Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Russian",
                    "degree": "BA"
                },
                {
                    "name": "Slavic East European Languages & Cultures",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Speech, Language and Hearing Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Speech, Language and Hearing Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Statistics",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Theatre & Drama",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Eskenazi School of Art, Architecture + Design",
            "source": {
                "label": "IU Bloomington, Browse All Degree Programs (bachelor's degrees)",
                "url": "https://bloomington.iu.edu/academics/degrees-majors/programs.html"
            },
            "majors": [
                {
                    "name": "Comprehensive Design",
                    "degree": "BS"
                },
                {
                    "name": "Fashion Design",
                    "degree": "BA"
                },
                {
                    "name": "Interior Design",
                    "degree": "BS"
                },
                {
                    "name": "Merchandising",
                    "degree": "BS"
                },
                {
                    "name": "Studio Art",
                    "degree": "BA"
                },
                {
                    "name": "Studio Art",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "Hamilton Lugar School of Global and International Studies",
            "source": {
                "label": "IU Bloomington, Browse All Degree Programs (bachelor's degrees)",
                "url": "https://bloomington.iu.edu/academics/degrees-majors/programs.html"
            },
            "majors": [
                {
                    "name": "Central Eurasia",
                    "degree": "BA"
                },
                {
                    "name": "Cybersecurity & Global Policy",
                    "degree": "BS"
                },
                {
                    "name": "East Asia",
                    "degree": "BA"
                },
                {
                    "name": "East Asian Languages & Cultures",
                    "degree": "BA"
                },
                {
                    "name": "International Financial Governance, Trade and Development",
                    "degree": "BS"
                },
                {
                    "name": "International Law and Institutions",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BS"
                },
                {
                    "name": "Middle East",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "The Media School",
            "source": {
                "label": "IU Bloomington, Browse All Degree Programs (bachelor's degrees)",
                "url": "https://bloomington.iu.edu/academics/degrees-majors/programs.html"
            },
            "majors": [
                {
                    "name": "Cinematic Arts",
                    "degree": "BFA"
                },
                {
                    "name": "Game Design",
                    "degree": "BS"
                },
                {
                    "name": "Global Media",
                    "degree": "BS"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Media",
                    "degree": "BA"
                },
                {
                    "name": "Media Advertising",
                    "degree": "BS"
                },
                {
                    "name": "Public Relations",
                    "degree": "BS"
                },
                {
                    "name": "Sports Media",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Kelley School of Business",
            "source": {
                "label": "IU Bloomington, Browse All Degree Programs (bachelor's degrees)",
                "url": "https://bloomington.iu.edu/academics/degrees-majors/programs.html"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS in Business"
                },
                {
                    "name": "Business",
                    "degree": "BS"
                },
                {
                    "name": "Business Intelligence and Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Economic Consulting",
                    "degree": "BS in Business"
                },
                {
                    "name": "Entrepreneurship and Corporate Innovation",
                    "degree": "BS in Business"
                },
                {
                    "name": "Finance",
                    "degree": "BS in Business"
                },
                {
                    "name": "Information Systems",
                    "degree": "BS in Business"
                },
                {
                    "name": "Management",
                    "degree": "BS in Business"
                },
                {
                    "name": "Marketing",
                    "degree": "BS in Business"
                },
                {
                    "name": "Marketing and Professional Sales",
                    "degree": "BS in Business"
                },
                {
                    "name": "Operations Management",
                    "degree": "BS in Business"
                },
                {
                    "name": "Public Policy Analysis",
                    "degree": "BS in Business"
                },
                {
                    "name": "Real Estate",
                    "degree": "BS in Business"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BS in Business"
                }
            ]
        },
        {
            "name": "Jacobs School of Music",
            "source": {
                "label": "Jacobs School of Music Bulletin 2026-2027, Undergraduate Division",
                "url": "https://bulletins.iu.edu/iub/music/2026-2027/undergraduate/index.shtml"
            },
            "majors": [
                {
                    "name": "Composition",
                    "degree": "BM"
                },
                {
                    "name": "Jazz Studies",
                    "degree": "BM"
                },
                {
                    "name": "Performance, Orchestral Instrument or Guitar",
                    "degree": "BM"
                },
                {
                    "name": "Performance, Organ",
                    "degree": "BM"
                },
                {
                    "name": "Performance, Piano",
                    "degree": "BM"
                },
                {
                    "name": "Performance, Voice",
                    "degree": "BM"
                },
                {
                    "name": "Performance, Woodwind Instruments (Multiple)",
                    "degree": "BM"
                },
                {
                    "name": "Choral Teaching",
                    "degree": "BME"
                },
                {
                    "name": "General Music Teaching",
                    "degree": "BME"
                },
                {
                    "name": "Instrumental Teaching, Band",
                    "degree": "BME"
                },
                {
                    "name": "Instrumental Teaching, Jazz",
                    "degree": "BME"
                },
                {
                    "name": "Instrumental Teaching, Strings",
                    "degree": "BME"
                },
                {
                    "name": "Music Business",
                    "degree": "BS"
                },
                {
                    "name": "Music Production",
                    "degree": "BS"
                },
                {
                    "name": "Music and an Outside Field",
                    "degree": "BS"
                },
                {
                    "name": "Music and an Outside Field (Ballet Emphasis)",
                    "degree": "BS"
                },
                {
                    "name": "Music and an Outside Field (Composition Emphasis)",
                    "degree": "BS"
                },
                {
                    "name": "Music and an Outside Field (Jazz Studies Emphasis)",
                    "degree": "BS"
                },
                {
                    "name": "Dance, Ballet Concentration",
                    "degree": "BFA"
                },
                {
                    "name": "Dance, Contemporary Dance Concentration",
                    "degree": "BFA"
                }
            ],
            "note": "Direct admission to a Jacobs major other than Theatre and Drama needs an audition and interview; you cannot begin as a pre-music major.",
            "noteSource": "paths"
        },
        {
            "name": "Luddy School of Informatics, Computing, and Engineering",
            "source": {
                "label": "IU Bloomington, Browse All Degree Programs (bachelor's degrees)",
                "url": "https://bloomington.iu.edu/academics/degrees-majors/programs.html"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Informatics",
                    "degree": "BS"
                },
                {
                    "name": "Intelligent Systems Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Robotics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "O'Neill School of Public and Environmental Affairs",
            "source": {
                "label": "IU Bloomington, Browse All Degree Programs (bachelor's degrees)",
                "url": "https://bloomington.iu.edu/academics/degrees-majors/programs.html"
            },
            "majors": [
                {
                    "name": "Arts Management",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Management",
                    "degree": "BS in Public Affairs"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Healthcare Management & Policy",
                    "degree": "BS"
                },
                {
                    "name": "Human Resource Management",
                    "degree": "BS in Public Affairs"
                },
                {
                    "name": "Law & Public Policy",
                    "degree": "BS in Public Affairs"
                },
                {
                    "name": "Nonprofit Management & Leadership",
                    "degree": "BS in Public Affairs"
                },
                {
                    "name": "Policy Analysis",
                    "degree": "BS in Public Affairs"
                },
                {
                    "name": "Public Financial Management",
                    "degree": "BS in Public Affairs"
                },
                {
                    "name": "Public Management & Leadership",
                    "degree": "BS in Public Affairs"
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "IU Bloomington, Browse All Degree Programs (bachelor's degrees)",
                "url": "https://bloomington.iu.edu/academics/degrees-majors/programs.html"
            },
            "majors": [
                {
                    "name": "Arts, Culture and World Languages Education",
                    "degree": "BS in Education"
                },
                {
                    "name": "Counseling and Student Services",
                    "degree": "BS in Education"
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "BS in Education"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BS in Education"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BS in Education"
                },
                {
                    "name": "Special Education - Elementary",
                    "degree": "BS in Education"
                },
                {
                    "name": "Special Education - Secondary",
                    "degree": "BS in Education"
                },
                {
                    "name": "Visual Arts Education",
                    "degree": "BS in Education"
                },
                {
                    "name": "World Languages Education",
                    "degree": "BS in Education"
                }
            ]
        },
        {
            "name": "School of Public Health",
            "source": {
                "label": "IU Bloomington, Browse All Degree Programs (bachelor's degrees)",
                "url": "https://bloomington.iu.edu/academics/degrees-majors/programs.html"
            },
            "majors": [
                {
                    "name": "Community Health",
                    "degree": "BS in Public Health"
                },
                {
                    "name": "Dietetics",
                    "degree": "BS in Applied Health Science"
                },
                {
                    "name": "Environmental Health",
                    "degree": "BS in Public Health"
                },
                {
                    "name": "Epidemiology",
                    "degree": "BS in Public Health"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS in Kinesiology"
                },
                {
                    "name": "Global Health",
                    "degree": "BS in Public Health"
                },
                {
                    "name": "Human Development and Family Studies",
                    "degree": "BS in Applied Health Science"
                },
                {
                    "name": "Nutrition Science",
                    "degree": "BS in Applied Health Science"
                },
                {
                    "name": "Parks, Recreation, and the Outdoors",
                    "degree": "BS in Health & Wellness Design"
                },
                {
                    "name": "Recreational Therapy",
                    "degree": "BS in Health & Wellness Design"
                },
                {
                    "name": "Safety Management",
                    "degree": "BS in Applied Health Science"
                },
                {
                    "name": "Sexual and Reproductive Health",
                    "degree": "BS in Public Health"
                },
                {
                    "name": "Sport Marketing & Management",
                    "degree": "BS in Kinesiology"
                },
                {
                    "name": "Tourism, Hospitality & Event Management",
                    "degree": "BS in Health & Wellness Design"
                },
                {
                    "name": "Youth Development",
                    "degree": "BS in Applied Health Science"
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "IU Bloomington, Browse All Degree Programs (bachelor's degrees)",
                "url": "https://bloomington.iu.edu/academics/degrees-majors/programs.html"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "School of Social Work",
            "source": {
                "label": "IU Bloomington, Browse All Degree Programs (bachelor's degrees)",
                "url": "https://bloomington.iu.edu/academics/degrees-majors/programs.html"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "BSW"
                }
            ]
        }
    ]
};

export default majors;
